import React from 'react';
import RowView from './RowView';
import { Image, StyleSheet, Linking } from 'react-native';
import { CommonProperties } from '../styles';
import BaseText from './BaseText';
import { TERMS_URL, PRIVACY_URL } from '../env.rebook';

export default function RebookFooter() {
  return (
    <RowView style={styles.footer}>
      <Image style={styles.footerLogoImg} source={require('../assets/img/icons/logo-home.png')} />
      <BaseText onPress={() => Linking.openURL(TERMS_URL)}>Terms |</BaseText>
      <BaseText style={styles.baseTextStyle} onPress={() => Linking.openURL(PRIVACY_URL)}>
        {' '}
        Privacy
      </BaseText>
      <BaseText style={styles.its}>(c) 2022 Internet Travel Solutions LLC</BaseText>
    </RowView>
  );
}

const styles = StyleSheet.create({
  footer: {
    ...CommonProperties.p4,
    flex: 1,
  },
  baseTextStyle: {
    paddingRight: '12px',
  },
  footerLogoImg: {
    height: 25,
    width: 100,
    resizeMode: 'contain',
    flex: 1,
  },
  its: {
    flex: 4,
  },
});
